module.exports = __webpack_public_path__ + "img/brand_33.bb6fdadc.png";